// extracted by mini-css-extract-plugin
export default {"wrapper":"live-toggle-module--wrapper--9091d","holder":"live-toggle-module--holder--36547","expanded":"live-toggle-module--expanded--9e46b"};